export const getEnvVariables = () => {
    return {
        ...process.env
    };
};
